/**
 *
 * @type {{check: (function()), user: (function()), login: (function())}}
 */
let auth = {
  check: () => {

  },
  user: () => {

  },
  login: () => {

  }
}

export default auth



// WEBPACK FOOTER //
// ./src/global/auth.js